module.exports = __webpack_public_path__ + "img/21.74a58e80.jpg";